import { VOUCHER_TYPE_DISCOUNT, BE_MY_GUEST_VOUCHER_DESCRIPTION, DISCOUNT_TYPE } from 'constants/vouchers';
import { STD, ER_STANDARD, STANDARD } from 'constants/classOfService';
import { productFamilyCodes } from 'types/productFamilyCodes';
import serviceTypeCodes from 'constants/serviceTypeCodes';
import { statusShortCode, codes } from 'constants/payment';
import moment from 'moment';
import { getSegmentsForItemRefs } from '../AfterSalesCtas.utils';

import {
  runAfterSaleValidator,
  allSegmentsOfType,
  allSegmentsOfService,
  allSegmentsInOneJourney,
  allSegmentsOfProductFamily,
  allSegmentsInOneDirection
} from '../AfterSalesCtas.utils';

export const buildProcessFreeUpgradeSegments = ({ fare, direction }) =>
  fare.legs.map((leg) => ({
    origin: leg.origin.uic,
    destination: leg.destination.uic,
    direction,
    departureDate: leg.timing.departureDate,
    serviceName: leg.serviceName,
    serviceIdentifier: leg.serviceIdentifier,
    items: leg.products.map(({ passengerId, tariffCode }) => ({
      passengerId,
      tariffCode
    }))
  }));

export const isFreeUpgradePossible = ({ booking, selectedItemRefs, salesChannelCode }) =>
  selectedItemRefs.length > 0 &&
  selectedItemRefs.length <= 4 &&
  ['EUROSTAR', 'EIL_DIGITAL'].includes(salesChannelCode) &&
  runAfterSaleValidator(
    booking,
    selectedItemRefs
  )([
    allSegmentsInOneDirection,
    allSegmentsInOneJourney,
    allSegmentsOfType([STD, ER_STANDARD, STANDARD]),
    allSegmentsOfService([serviceTypeCodes.EUROSTAR, serviceTypeCodes.GREENSPEED]),
    allSegmentsOfProductFamily([productFamilyCodes.PUB])
  ]);

export const hasBookingBeenUpgradedForFree = ({ payments = [], bookingVouchers = [], getVouchersResponse = [] }) => {
  if (!bookingVouchers || !getVouchersResponse) return false;
  const vouchersPayments = payments.filter(
    ({ paymentStatus, method }) => paymentStatus === statusShortCode.success && method === codes.VOUCHER
  );
  if (!vouchersPayments) return false;
  return !!getVouchersResponse.find(
    ({ reference, alias }) =>
      bookingVouchers.find(({ code, class: voucherClass }) => voucherClass === DISCOUNT_TYPE && reference === code) &&
      vouchersPayments.find((voucherPayment) => voucherPayment.reference === alias.slice(-4))
  );
};

export const buildGetVouchersQuery = ({ currency }) => ({
  fromDate: moment().startOf('month').format('YYYY-MM-DD'),
  toDate: moment().format('YYYY-MM-DD'),
  active: true,
  description: BE_MY_GUEST_VOUCHER_DESCRIPTION,
  voucherType: VOUCHER_TYPE_DISCOUNT,
  convertTotalToCurrency: currency
});

export const buildUpgradableFareInfo = ({ booking, selectedItemRefs }) => {
  const segments = Array.from(getSegmentsForItemRefs(booking, selectedItemRefs))?.[0];
  return {
    direction: segments?.direction,
    carrier: segments?.serviceType?.code,
    trainNumber: segments?.trainNumber,
    date: moment(segments?.timing?.date).format('dddd D MMMM YYYY')
  };
};

export const getMaxTicketDifference = (legs) => {
  const allProducts = legs.flatMap(({ products }) => products);

  const oldProducts = allProducts.filter(({ cancelled, provisional }) => cancelled && provisional);
  const newProducts = allProducts.filter(({ cancelled, provisional }) => cancelled === false && provisional);

  const differences = newProducts.map(({ passenger: { id }, price }) => {
    const matchingOldProduct = oldProducts.find(({ passenger }) => passenger.id === id);
    return matchingOldProduct ? price - matchingOldProduct.price : 0;
  });

  return Math.max(...differences, 0);
};
